/**
 * Salesforce-issued community topic IDs that the application pins/special-cases
 * in `categorizeCommunities` (see `src/utils/communitiesUtils.ts`).
 *
 * Names mirror the historical `communitytop` / `communitybottom` fields they
 * filter into.
 */
export const FEATURED_COMMUNITY_ID_TOP = "0TO3i0000008jYHGAY";
export const FEATURED_COMMUNITY_ID_BOTTOM = "0TO3i00000094ZjGAI";

export const FEATURED_COMMUNITY_IDS = [
  FEATURED_COMMUNITY_ID_TOP,
  FEATURED_COMMUNITY_ID_BOTTOM,
] as const;
